<script>
import CountdownBig from './CountdownBig';
import CountdownSmall from './CountdownSmall';
const livedata = $$.module.data.room;

export default {
  name: 'Countdown',
  components: {
    CountdownBig,
    CountdownSmall
  },
  props: {
    type: {
      type: String,
      default: 'small'
    }
  },
  data() {
    return {
      localReserveFlg: false,
      api: $$.module.interview.$api
    };
  },
  methods: {
    reserveHandle() {
      if (this.localReserveFlg || $$.module.data.room.roomMemberInfo.reservationFlg) {
        return;
      }
      this.api.addReservation({
        data: { roomId: livedata.roomId, roomType: '1' },
        success: () => {
          this.$toast.success('预约成功');
          this.localReserveFlg = true;
          $$.module.data.room.roomMemberInfo.reservationFlg = true;
        },
        excption: () => {
          this.$toast.fail('预约失败');
        }
      });
    },
    countDownFinish() {
      window.__LIVE__.initData();
    }
  },
  render() {
    const props = {
      props: {
        ...this.$attrs,
        reserveFlg: this.localReserveFlg || $$.module.data.room.roomMemberInfo.reservationFlg
      },
      on: {
        reserve: this.reserveHandle,
        finish: this.countDownFinish
      }
    };
    return this.type === 'small' ? <CountdownSmall {...props}></CountdownSmall> : <CountdownBig {...props}></CountdownBig>;
  }
};
</script>
